var _circle, _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBridge40PxSelected(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "bridge",
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 58,
    viewBox: "0 0 40 58",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 20,
    cy: 55,
    r: 3,
    fill: "#FF2E00"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20,48,34.142,33.521a19.531,19.531,0,0,0,5.474-10.054,19.315,19.315,0,0,0-1.138-11.345,19.725,19.725,0,0,0-7.367-8.813,20.309,20.309,0,0,0-22.222,0,19.725,19.725,0,0,0-7.367,8.813A19.315,19.315,0,0,0,.384,23.467,19.531,19.531,0,0,0,5.858,33.521Z",
    fill: "#FF2E00"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    transform: "translate(12.5,12.5)",
    fill: "#ffffff",
    d: "M0,8.842V13h2v-1c0.036-1.089,0.911-1.964,2-2c1.089,0.036,1.964,0.911,2,2v1h3v-1c0.036-1.089,0.911-1.964,2-2 c1.089,0.036,1.964,0.911,2,2v1h2V8.842C10.6,3.082,3.071,4.4,0,8.842z M9.5,5.734c0.514,0.121,1.016,0.289,1.5,0.5V9H9.5V5.734z M9,5.634V9H7.5V5.506C8.003,5.506,8.505,5.549,9,5.634z M3.5,6.477C3.98,6.229,4.482,6.026,5,5.871V9H3.5V6.477z M5.5,9V5.73 C5.993,5.615,6.495,5.543,7,5.515V9H5.5z M3,6.744V9H0.5C1.176,8.094,2.032,7.328,3,6.744z M11.5,9V6.5l-0.053-0.053 C12.649,7.05,13.694,7.924,14.5,9H11.5z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBridge40PxSelected);
export default __webpack_public_path__ + "static/media/bridge_40px_selected.b9c9bfa8180a30f174a00bf78869df5d.svg";
export { ForwardRef as ReactComponent };